import { v4 as makeUuid } from 'uuid'
import { AxiosInstance } from 'axios'
import { IUrlUtils } from 'v2/modules/lib'

export interface IUserServiceArgs {
  httpClient: AxiosInstance
  urlUtils: IUrlUtils
}

export const makeUserService = ({ httpClient, urlUtils }: IUserServiceArgs) => {
  const getUserSettings = async (
    accountId: string,
    userId: string,
    variables: string[]
  ): Promise<Array<Record<string, any>>> => {
    const res = await httpClient.get(
      `/user-service/account/${urlUtils.urlEncode(accountId)}/user/${urlUtils.urlEncode(userId)}/settings`,
      {
        params: {
          variables: variables.join(',')
        },
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const saveUserSettings = async (accountId: string, userId: string, settings: Array<Record<string, any>>) => {
    const res = await httpClient.put(
      `/user-service/account/${urlUtils.urlEncode(accountId)}/user/${urlUtils.urlEncode(userId)}/settings`,
      settings,
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const getUserQnsSettings = async (
    accountId: string,
    userId: string,
    effective = false
  ): Promise<Record<string, any>> => {
    const res = await httpClient.get(
      `/user-service/account/${urlUtils.urlEncode(accountId)}/user/${urlUtils.urlEncode(userId)}/qns-settings`,
      {
        params: {
          effective: effective ? 'true' : 'false'
        },
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const saveUserQnsSettings = async (accountId: string, userId: string, settings: Record<string, any>) => {
    const res = await httpClient.put(
      `/user-service/account/${urlUtils.urlEncode(accountId)}/user/${urlUtils.urlEncode(userId)}/qns-settings`,
      settings,
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  return Object.freeze({
    getUserSettings,
    saveUserSettings,
    getUserQnsSettings,
    saveUserQnsSettings
  })
}
